<snelstart-venture-fiscaal-feature-lijfrente-premies [partner]="partner"></snelstart-venture-fiscaal-feature-lijfrente-premies>

<snelstart-venture-fiscaal-feature-jaarruimtegegevens [partner]="partner"></snelstart-venture-fiscaal-feature-jaarruimtegegevens>
